import { Flex } from '@shared/components';

import { NewQSetReviewTaskDetailsSection } from '../new-qset-review-task-details-section';
import { QSetSubTaskDetailsAccordionGroup } from '../qset-subtask-details-accordion-group';

export default function NewQSetReviewTaskDetails() {
  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
      <NewQSetReviewTaskDetailsSection />
      <QSetSubTaskDetailsAccordionGroup />
    </Flex>
  );
}
